import { Address, AddressInput } from '@adc/sdk/types'
import * as graph from '@adc/sdk'

export const mapLeadAddressToStandardPropertyAddress = (
  value: Record<string, string>
): AddressInput => ({
  street_number: value['property.street_number'],
  street_name: value['property.address'],
  street_unit: value['property.street_unit'],
  municipality: value['property.city'],
  country_secondary_subdivision: value['property.county'],
  country_primary_subdivision: value['property.state'],
  postal_code: value['property.postal_code'],
  country_code: value['property.country_code'],
  source: graph.enums.AddressSource.Google,
})

export const mapStandardPropertyAddressToLeadAddress = (
  address: Address
): Record<string, any> => ({
  'property.street_number': address.street_number,
  'property.address': address.street_name,
  'property.street_unit': address.street_unit,
  'property.city': address.municipality,
  'property.county': address.country_secondary_subdivision,
  'property.state': address.country_primary_subdivision,
  'property.postal_code': address.postal_code,
  'property.address_source': address.source,
  'property.country_code': address.country_code,
})

export const mapDisplayAddressFromQueryParams = (
  address: Record<string, string>
): Record<string, string> => {
  // Street address
  const streetParts = [
    address.street_number,
    address.street_name,
    address.street_unit ? `#${address.street_unit}` : null,
  ].filter(Boolean)

  const street = streetParts.join(' ')

  const addressParts = [
    street,
    address.municipality,
    // country_primary_subdivision and postal_code together
    [address.country_primary_subdivision, address.postal_code]
      .filter(Boolean)
      .join(' ') || null,
    address.country_code,
  ].filter(Boolean)

  if (addressParts.length === 0) {
    return {}
  }

  return {
    '__computed__.property.addressDisplayText': addressParts.join(', '),
  }
}
